import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-458e7c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "think-helpful" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "count" }

import { computed } from 'vue';
  import { request } from '@/utils';
  import { IArticle, getArticleDefaultData } from '@/types/article';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    modelValue: IArticle;
  }

  interface IEmits {
    (event: 'update:modelValue', modelValue: IArticle): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: () => getArticleDefaultData() }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: IArticle): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: IArticle }

  const { t } = useI18n();
  
  

  const actionDisabled = computed(() => {
    return props.modelValue.think_helpful || props.modelValue.think_not_helpful;
  });

  async function thinkHelpful() {
    await request.post('action_stores', { action_type: 'think_helpful', target_type: 'Article', target_id: props.modelValue.id });
    emits('update:modelValue', { ...props.modelValue, think_helpful: true, helpful_count: props.modelValue.helpful_count + 1, reviews_count: props.modelValue.reviews_count + 1 });
  }

  async function thinkNotHelpful() {
    await request.post('action_stores', { action_type: 'think_not_helpful', target_type: 'Article', target_id: props.modelValue.id });
    emits('update:modelValue', { ...props.modelValue, think_not_helpful: true, not_helpful_count: props.modelValue.not_helpful_count + 1, reviews_count: props.modelValue.reviews_count + 1 });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('title')), 1),
    _createElementVNode("button", {
      class: "btn btn-outline-primary",
      disabled: _unref(actionDisabled),
      onClick: thinkHelpful
    }, _toDisplayString(_unref(t)('yes')), 9, _hoisted_3),
    _createElementVNode("button", {
      class: "btn btn-outline-primary",
      disabled: _unref(actionDisabled),
      onClick: thinkNotHelpful
    }, _toDisplayString(_unref(t)('no')), 9, _hoisted_4),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('found_this_helpful', { helpfulCount: __props.modelValue.helpful_count, reviewsCount: __props.modelValue.reviews_count })), 1)
  ]))
}
}

})